import { BuyerDocumentSelector } from 'components/BuyerDocumentSelector';
import { localizable } from 'components/Localization';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import {
  DefaultButton,
  PrimaryButton,
} from 'office-ui-fabric-react/lib/Button';
import {
  Dialog,
  DialogFooter,
  DialogType,
} from 'office-ui-fabric-react/lib/Dialog';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
// eslint-disable-next-line no-unused-vars
import { TextField } from 'office-ui-fabric-react';
import { getDefaultUploadTypes } from 'helpers/uploadTypes';

@localizable
@observer
export default class SelfRegistrationApprovalDialog extends Component {
  static propTypes = {
    sale: PropTypes.object.isRequired,
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
  };

  @observable.shallow requiredUploads = []; // just keys
  @observable.shallow optionalUploads = []; // just keys
  @observable paddleNumber = '';

  get config() {
    const { sale } = this.props;
    return sale.root.saleConfig;
  }

  componentDidMount() {
    const { offer, sale } = this.props;
    const { requiredUploadTypes = [] } = this.config;
    const defaultUploadTypes = getDefaultUploadTypes(
      this.config,
      sale.offerData
    );

    if (offer.data) {
      if (offer.data.required_uploads)
        this.requiredUploads.replace(offer.data.required_uploads);
      if (offer.data.optional_uploads)
        this.optionalUploads.replace(offer.data.optional_uploads);
    }

    if (!this.requiredUploads.length) {
      defaultUploadTypes.forEach((type) => {
        if (!this.requiredUploads.includes(type))
          this.requiredUploads.push(type);
      });
    }

    requiredUploadTypes.forEach((type) => {
      if (!this.requiredUploads.includes(type)) this.requiredUploads.push(type);
    });
  }

  handleSubmit = () => {
    const { offer, onSubmit } = this.props;
    const _offer = Object.assign({}, offer, {
      offerData: Object.assign({}, offer.data, {
        required_uploads: this.requiredUploads,
        optional_uploads: this.optionalUploads,
        // paddle_number: this.paddleNumber,
      }),
    });
    onSubmit(_offer);
  };

  render() {
    const { onClose, t } = this.props;
    const { uploadTypes = [], requiredUploadTypes = [] } = this.config;
    const localizedUploadTypes = uploadTypes.map((key) => {
      return { key: key, text: t(`uploadtype::${key}`) };
    });

    return (
      <Dialog
        minWidth={600}
        hidden={false}
        onDismiss={onClose}
        dialogContentProps={{
          type: DialogType.largeHeader,
          title: t('Approve Registration'),
        }}
        modalProps={{
          isBlocking: true,
          containerClassName: 'ms-dialogMainOverride',
        }}
      >
        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-lg12 ms-md12 ms-sm12">
              <BuyerDocumentSelector
                label={t('Documents')}
                options={localizedUploadTypes}
                required={this.requiredUploads}
                // optional={this.optionalUploads}
                disabled={requiredUploadTypes}
              />
            </div>
            {/* <div className="ms-Grid-col ms-lg12 ms-md12 ms-sm12">
              <TextField
                label={t('Paddle number')}
                value={this.paddleNumber}
                onChange={(_, v) => {
                  this.paddleNumber = v;
                }}
                autoComplete="off"
              />
            </div> */}
          </div>
        </div>

        <DialogFooter>
          <PrimaryButton onClick={this.handleSubmit} text={t('Approve')} />
          <DefaultButton onClick={onClose} text={t('Cancel')} />
        </DialogFooter>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/OffersSection/SelfRegistrationApprovalDialog.jsx